export default __webpack_public_path__ + "d40e792426adeae442bcfcbdeea8ce42.png";